import React, { Component } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import CardMedia from "@material-ui/core/CardMedia";
import Modal from "@material-ui/core/Modal";
import Paper from "@material-ui/core/Paper";
import Grid from '@material-ui/core/Grid';

import Photo from "../Photo/Photo"
class PhotosEvent extends Component {
	state = {
		data: ""
    };
    
    constructor(props) {
		super(props);
		this.state = {
		};
	}

	componentDidMount() {
		this.state = {
		};
	}

	handleConfirm = () => {
		this.props.handleEventDelete(this.props.id , this.props.token);
		this.handleCancel();
	};

	handleCancel = () => {
		this.setState({
			modal: false
		});
	};

	openModal = () => {
		console.log("OPENM MODAL");
		this.setState({
			modal: true
		});
	};
	render() {
		return (
			<React.Fragment>
				<Modal
					aria-labelledby="simple-modal-title"
					aria-describedby="simple-modal-description"
					open={this.state.modal}
				>
					<Paper
						style={{
							display: "grid",
							width: "30%",
							padding: "50px",
							margin: "20% auto"
						}}
					>
						<div style={{ textAlign: "center" }}>
							Desea Borrar?
							<br />
							<br />
							<br />
							<Button
								onClick={this.handleConfirm}
								type="submit"
								color="secondary"
								variant="contained"
							>
								Confirmar
							</Button>
							&nbsp;&nbsp;&nbsp;
							<Button
								onClick={this.handleCancel}
								color="primary"
								variant="contained"
							>
								Cancelar
							</Button>
						</div>
					</Paper>
				</Modal>

				<Card style={{ width: "100%", marginBottom: 10 }}>
					<CardContent>
						<TextField
							id="outlined-basic"
							label="Nombre"
							variant="outlined"
							value={this.props.name}
							style={{ width: "90%" }}
						/>
						<br />
						<Grid container spacing={3} style={{marginTop:"20px"}}>
        
						{this.props.photos.map(p => (
							<Grid xs={6} sm={3}>
								<Photo 
									id={p.idphoto} 
									name={p.name} 
									photourl={p.photourl} 
									thumbnailurl={p.thumbnailurl} 
									handlePhotoDelete={this.props.handlePhotoDelete}
								/>
							</Grid>
						))}
						</Grid>
					</CardContent>

					<CardActions>
						<Button
							color="secondary"
							onClick={() => {
								this.openModal();
							}}
						>
							Borrar
						</Button>
						<Button
							color="primary"
							onClick={() => {
								this.props.addPhotos(this.props.id, this.props.name);
							}}
						>
							Agregar Fotos
						</Button>
					</CardActions>
				</Card>
			</React.Fragment>
		);
	}
}
export default PhotosEvent;
